import React from 'react';
import classnames from 'classnames';

import Icon from 'components/UI/Icon';

import convertToSlug from 'helpers/stringToSlug';

import * as styles from './techInfo.module.scss';

const TechInfo = ({ tag = '', questionCount = 0, time = 0 }) => {
  const tagClass = convertToSlug(tag);

  return (
    <div className={classnames(styles.flex)}>
      {tag ? (
        <p className={classnames('scr-article-tag')}>
          <span className={classnames(`tag-${tagClass}`, 'tag-common')}>
            {tag}
          </span>
        </p>
      ) : null}

      <p className={classnames(styles.item, 'scr-txt-up scr-blue')}>
        <Icon name="chat" />
        &#160;
        <span>{questionCount}</span>
        &#160;
        <span>questions</span>
      </p>

      <p className={classnames(styles.item, 'scr-txt-up scr-blue')}>
        <Icon name="clock" />
        &#160;
        <span>{time}</span>
        &#160;
        <span>min to pass</span>
      </p>
    </div>
  );
};

export default TechInfo;
